module.exports = __webpack_public_path__ + "img/Tessellate50.296ce033.jpg";